export class MarkerCT {
}
